import { GtmCustomData, getGtmData, recordEventWrapper } from '..';
import { replaceEmptySpaceWithHyphen } from '../../utils/common';
import { SchemeListDataGTM } from '../utils';
const investBasisRiskProfile = () => ({
  // 1. Invest Basis Risk Profile Home page
  riskProfilePageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/explore-mutual-funds/invest-basis-your-risk-profile/home',
    //   title: 'PFM - Online Investments - Explore Mutual Funds - Invest Basis Your Risk Profile - Home'
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Explore Mutual Funds - Invest Basis Your Risk Profile - Landing Screen'
    // })
  },

  // actionType can be either Back or I am Confused.
  riskProfileClickEvent: (actionType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Invest Basis Your Risk Profile - Landing Screen - ${actionType}`,
    // })
  },

  // Data here will have cd72 
  riskProfileOnNextClick: (data: GtmCustomData) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Explore Mutual Funds - Invest Basis Your Risk Profile - Landing Screen - Next',
    //   ...data
    // })
  },

  // 2. Risk Profile loaded page
  riskProfileCalculatedPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: 'vpv/pfm/online-investments/explore-mutual-funds/invest-basis-your-risk-profile/i-am-confused/risk-profile',
    //   title: 'PFM - Online Investments - Explore Mutual Funds - Invest Basis Your Risk Profile - I am Confused - Risk Profile'
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Explore Mutual Funds - Invest Basis Your Risk Profile - I am Confused - Risk Profile'
    // })
  },

  riskProfileCalculatedExploreSchemesClick: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Explore Mutual Funds - Invest Basis Your Risk Profile - I am Confused - Explore Schemes Basis Your Risk Profile'
    // })
  },

  // 3. Explore page
  // data will have cd24 as value
  explorePageLoad: (data: GtmCustomData) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/invest-basis-your-risk-profile/explore-mutual-funds',
    //   title: 'PFM - Online Investments - Invest Basis Your Risk Profile - Explore Mutual Funds',
    //   ...data
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Invest Basis Your Risk Profile - Explore Mutual Funds - Landing Screen'
    // })
  },

  explorePageBackClick: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Invest Basis Your Risk Profile - Explore Mutual Funds - Back'
    // })
  },

  // fundType will be Equity Funds, Debt Funds, Hybrid Funds, etc.
  explorePageFundClick: (fundType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Invest Basis Your Risk Profile - Explore Mutual Funds - ${fundType}`
    // })
  },

  // 4. Scheme list page
  // TODO
  schemeListPageLoad: (data: SchemeListDataGTM) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/invest-basis-your-risk-profile/explore-mutual-funds/${data?.fundCategory?.toLowerCase()}-funds/${replaceEmptySpaceWithHyphen(data?.fundSubCategory, true)}`,
    //   title: `PFM - Online Investments - Invest Basis Your Risk Profile - Explore Mutual Funds - ${data?.fundCategory} Funds - ${data?.fundSubCategory}`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Invest Basis Your Risk Profile - Explore Mutual Funds - ${data?.fundCategory} Funds - ${data?.fundSubCategory}`
    // })
  },

  // Fundcategory will be either Equity, Hybrid, Debt, etx.
  schemeListPageBackClick: (fundCategory: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Invest Basis Your Risk Profile - Explore Mutual Funds - ${fundCategory} Funds - Back`
    // })
  },

  schemeSelectionOnFilter: (data: SchemeListDataGTM) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: `vpv/pfm/online-investments/explore-mutual-funds/${data?.fundCategory?.toLowerCase()}-funds/${replaceEmptySpaceWithHyphen(data?.fundSubCategory, true)}`,
    //   title: `PFM - Online Investments - Invest Basis Your Risk Profile - Explore Mutual Funds - ${data?.fundCategory} Funds - ${data?.fundSubCategory}`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Invest Basis Your Risk Profile - Explore Mutual Funds - ${data?.fundCategory} Funds - ${data?.fundSubCategory}`
    // })
  },

  // Fund category can be equity, hybrid, debt, etc..
  onAxisSelectToggle: (fundCategory: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: `vpv/pfm/online-investments/invest-basis-your-risk-profile/explore-mutual-funds/${fundCategory.toLowerCase()}-funds/axis-select`,
    //   title: `PFM - Online Investments - Invest Basis Your Risk Profile - Explore Mutual Funds - ${fundCategory} Funds - Axis Select`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Invest Basis Your Risk Profile - Explore Mutual Funds - ${fundCategory} Funds - Axis Select`
    // })
  },

  onInvestClick: (scheme: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Invest Basis Your Risk Profile - Explore Mutual Funds - ${scheme} - Invest`, 
    //   cd66: getGtmData('cd66'),
    //   cd67: getGtmData('cd67')
    // })
  },

  // 5. Invest Page
  investPageLoad: (scheme: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/invest-basis-your-risk-profile/explore-mutual-funds/${replaceEmptySpaceWithHyphen(scheme, true)}/home`,
    //   title: `PFM - Online Investments - Invest Basis Your Risk Profile - Explore Mutual Funds - ${scheme} - Home`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Invest Basis Your Risk Profile - Explore Mutual Funds - ${scheme} - Landing Screen`
    // })
  },

  // actionType can be Back, Terms and Conditions, Add Nominee, Edit Nominee
  investPageOnClickEvent: (scheme: string, actionType: string, userFlow?) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow.toLowerCase()} | ${scheme}`,
      label: `${actionType}`
    })
  },

  // data will have cd68, cd69, cd70 and cd74 values
  investPageOnContinueClick: (scheme: string, data: GtmCustomData, userFlow?, isLumpsum?) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow.toLowerCase()} | ${scheme}`,
      label: `continue | ${isLumpsum ? "Lumpsum" : "SIP"}`,
      ...data
    })
  },

  // 6. Nominee Modal
  nomineeModalPageLoad: (scheme: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/invest-basis-your-risk-profile/explore-mutual-funds/${replaceEmptySpaceWithHyphen(scheme, true)}/home/add-nominee`,
    //   title: `PFM - Online Investments - Invest Basis Your Risk Profile - Explore Mutual Funds - ${scheme} - Home - Add Nominee`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Invest Basis Your Risk Profile - Explore Mutual Funds - ${scheme} - Landing Screen - Add Nominee`
    // })
  },

  // actionType can be Close, Remove, Add Another Nominee, Confirm Nominee
  nomineeModalActionClick: (scheme: string, actionType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Invest Basis Your Risk Profile - Explore Mutual Funds - ${scheme} - Landing Screen - Add Nominee - ${actionType}`
    // })
  },

  // 8. Verify OTP modal
  otpModalPageLoad: (scheme: string, userFlow?) => {
    recordEventWrapper({
      event: 'event_pfm_onload_vpv',
      page: `/vpv/pfm/mutual-funds/${userFlow.toLowerCase()}/otp-verification`,
      title: `PFM - Mutual Funds - ${userFlow.toLowerCase()} - OTP Verification`
    }),
    recordEventWrapper({
      event: 'event_pfm_onload',
      category: 'PFM',
      action: 'Pageload',
      label: `mutual funds | ${userFlow?.toLowerCase()} - - otp verification`
    })
  },

  // actionType can be either Close or Submit
  otpModalActionClick: (scheme: string, actionType: string, userFlow?) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow?.toLowerCase()} - otp verification`,
      label: `success | ${scheme}`
    })
  },

  // 9. Transaction successful page
  // Data will have cd71 as value
  investSuccessPageLoad: (scheme: string, data: GtmCustomData) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/invest-basis-your-risk-profile/explore-mutual-funds/${replaceEmptySpaceWithHyphen(scheme)}/investment-successful`,
    //   title: `PFM - Online Investments - Invest Basis Your Risk Profile - Explore Mutual Funds - ${scheme} - Investment Successful`,
    //   ...data
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Invest Basis Your Risk Profile - Explore Mutual Funds - ${scheme} - Investment Successful`
    // })
  },

  investSuccessPageGoBackTextClick: (scheme: string, goBackMessage: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Invest Basis Your Risk Profile - Explore Mutual Funds - ${scheme} - Investment Successful - ${goBackMessage}`
    // })
  },

  // actionButton will be the text of the buttons, can be "Every Goal Deserves a SIP. Start one more SIP" pr "Start a SIP in International Funds"
  investSuccessActionButtonsClick: (scheme: string, actionButton: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Invest Basis Your Risk Profile - Explore Mutual Funds - ${scheme} - Investment Successful - ${actionButton}`
    // })
  }

})

export default investBasisRiskProfile;